export default __webpack_public_path__ + "3bb1688728c3742d2214c7bb46138afb.png";